export class ETFsEnvironment {
  public static getName = () => 'benzinga-etfs';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://www.benzinga.com/lavapress/api/'),
  });
}
